export default __webpack_public_path__ + "static/media/IconMinus.8867935e.svg";